import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2485fd6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "node__value"
}
const _hoisted_2 = { class: "node__value-text" }
const _hoisted_3 = { class: "node__value-type" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_node = _resolveComponent("node")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node, (value, key) => {
    return (_openBlock(), _createElementBlock("li", {
      class: "node",
      key: key
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["node__key", { '_is-alone': _ctx.isObject(value) }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.isExists(key)), 1)
      ], 2),
      (!_ctx.isObject(value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.isExists(value)), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(typeof value), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isObject(value))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createVNode(_component_node, { node: value }, null, 8, ["node"])
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}